import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import whatwedoimage2 from "../../assets/images/WhatwedoImage2.png";
import whatwedo2 from "../../assets/images/Whatwedo/whatwedo2.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const WhatwedoContent = () => {

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        width: "100%",
        padding: "0rem 0rem",
        display: "flex",
        justifyContent: { xs: "start", md: "flex-start" },
        alignItems: "center",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box
        sx={{
          width: { xs: "80%", sm: "55%", md: "40%" },
        }}
      >
        <Box
          sx={{
            width: { xs: "auto", md: "28rem" },
          }}
        >
          <LazyLoadImage
            src={isMdUp ? whatwedoimage2 : whatwedo2}
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "58%" },
          padding: "1rem 2rem 2rem 2rem",
        }}
      >
        <Typography
          sx={{
            color: "rgba(51, 51, 51, 1)",
            fontFamily: "Plus Jakarta Sans",
            marginBottom: "1.5rem",
            fontSize: "1rem",
            lineHeight: "1.6",
          }}
        >
          Whether you're looking to enhance customer experience, streamline
          operations, or explore new market opportunities, our data-driven
          approach will help you achieve your goals.
        </Typography>
        <Typography
          sx={{
            color: "rgba(51, 51, 51, 1)",
            fontFamily: "Plus Jakarta Sans",
            marginBottom: "1.5rem",
            fontSize: "1rem",
            fontWeight: "500",
          }}
        >
          Here's how we help you solve business problems:
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <Typography sx={{ color: "rgba(243, 107, 43, 1)" }}>•</Typography>
            <Typography
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              <span
                style={{ color: "rgba(243, 107, 43, 1)", fontWeight: "600", fontFamily: "Plus Jakarta Sans" }}
              >
                Sharper recommendations based on holistic data analytics:{" "}
              </span>
              Rather than giving recommendations based on a single source of
              data, our expertise lies in aggregating and analysing data across
              multiple sources — be it macro-economic trends, consumer and
              retail research, customer feedback, social media trends, sales
              data, or industry benchmarks. The unified data view ensures that
              no aspect of the business is missed out and the solution is truly
              based on comprehensive understanding of the business.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <Typography sx={{ color: "rgba(243, 107, 43, 1)" }}>•</Typography>
            <Typography
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              <span
                style={{ color: "rgba(243, 107, 43, 1)", fontWeight: "600", fontFamily: "Plus Jakarta Sans" }}
              >
                Advanced Analytics for Strategic Solutions:{" "}
              </span>
              Our data analytics expertise goes beyond number-crunching. We dive
              deep into the data, applying sophisticated analytical techniques
              to uncover patterns, trends, and correlations that directly inform
              your strategic decisions.
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <Typography sx={{ color: "rgba(243, 107, 43, 1)" }}>•</Typography>
            <Typography
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                fontSize: "1rem",
                lineHeight: "1.6",
              }}
            >
              <span
                style={{ color: "rgba(243, 107, 43, 1)", fontWeight: "600", fontFamily: "Plus Jakarta Sans" }}
              >
                Customized Solutions for Your Unique Needs:{" "}
              </span>
              Every business has its own set of challenges. We tailor our data
              integration and analytics services to meet the specific needs of
              your organization, ensuring that the insights we provide are not
              just relevant, but transformative.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default WhatwedoContent;
